/**
 * @module download
 * @desc 文件下载
 * @author: Liang Huang
 * @date: 2019-06-04
 */

/**
 * 使用A标题下载
 * @function
 * @param {Stirng|Blob} url 资源URL
 * @param {*} fileName 保存文件名
 * @param {*} isBlob 是否Blob资源
 */
export var saveUrl = function saveUrl(url, fileName, isBlob) {
  var newA = document.createElement('a');
  newA.href = url;
  newA.style.display = 'none';
  newA.target = '_blank';

  if (fileName) {
    newA.download = fileName;
  }

  document.body.appendChild(newA);
  setTimeout(function () {
    newA.click();
    document.body.removeChild(newA);

    if (isBlob) {
      window.URL.revokeObjectURL(newA.href);
    }
  }, 0);
};
/**
 * 使用Blob下载
 * 注意：1. 链接禁止跨域 2. 协议与当前页面要一致
 * @function
 * @param {String} url 文件链接
 * @param {String} fileName 保存文件名
 */

export var saveUrlBlob = function saveUrlBlob(url, fileName, withCredentials) {
  var newAjax = new XMLHttpRequest();
  newAjax.open('GET', url, true);
  newAjax.responseType = 'blob';

  if (withCredentials) {
    newAjax.withCredentials = true;
  }

  newAjax.onload = function (e) {
    saveUrl(URL.createObjectURL(newAjax.response), fileName, true);
  };

  newAjax.send();
};
/**
 * 文件下载
 * @function
 * @param {String} url 文件地址
 * @param {String} fileName 文件名
 */

export var download = function download(url, fileName, withCredentials) {
  if (withCredentials === void 0) {
    withCredentials = false;
  }

  saveUrlBlob(url, fileName, withCredentials);
};